export default class vimeoPopup {

	constructor() {
		this.container = document.querySelector('.vimeo-video');
		this.containerSecond = document.querySelector('.vimeo-video-second');
		this.containerThird = document.querySelector('.vimeo-video-third');
		this.containerFull = document.querySelector('.vimeo-video-full');
		// Is the element present on the current page
		if (this.container) {
			this.vimeo = document.querySelectorAll('.vimeo-video');
			this.closeButton = document.querySelector('.vimeo-video-popup-close');
			this.vidUrl = document.getElementById('vimeo-iframe');
			this.vidUrlSrc = this.vidUrl.src;
			for (let i = 0; i < this.vimeo.length; i++) {
				this.vimeo[i].addEventListener('click', () => {
					this.openVideo();
				});
			}
			this.closeButton.addEventListener('click', () => {
				this.closeVideo();
			});
		}
		if (this.containerSecond) {
			this.vimeoSecond = document.querySelectorAll('.vimeo-video-second');
			this.closeButtonSecond = document.querySelector('.vimeo-video-popup-close-second');
			this.vidUrlSecond = document.getElementById('vimeo-iframe-second');
			if (this.vidUrlSecond) {
				this.vidUrlSrcSecond = this.vidUrlSecond.src;
			}
			for (let i = 0; i < this.vimeoSecond.length; i++) {
				this.vimeoSecond[i].addEventListener('click', () => {
					this.openVideoSecond();
				});
			}
			if (this.closeButtonSecond) {
				this.closeButtonSecond.addEventListener('click', () => {
					this.closeVideoSecond();
				});
			}
		}
		if (this.containerThird) {
			this.vimeoThird = document.querySelectorAll('.vimeo-video-third');
			this.closeButtonThird = document.querySelector('.vimeo-video-popup-close-third');
			this.vidUrlThird = document.getElementById('vimeo-iframe-third');
			if (this.vidUrlThird) {
				this.vidUrlSrcThird = this.vidUrlThird.src;
			}
			for (let i = 0; i < this.vimeoThird.length; i++) {
				this.vimeoThird[i].addEventListener('click', () => {
					this.openVideoThird();
				});
			}
			if (this.closeButtonThird) {
				this.closeButtonThird.addEventListener('click', () => {
					this.closeVideoThird();
				});
			}
		}
		if (this.containerFull) {
			this.vimeoFull = document.querySelectorAll('.vimeo-video-full');
			this.closeButtonFull = document.querySelector('.vimeo-video-popup-close-full');
			this.vidUrlFull = document.getElementById('vimeo-iframe-full');
			if (this.vidUrlFull) {
				this.vidUrlSrcFull = this.vidUrlFull.src;
			}
			for (let i = 0; i < this.vimeoFull.length; i++) {
				this.vimeoFull[i].addEventListener('click', () => {
					this.openVideoFull();
				});
			}
			if (this.closeButtonFull) {
				this.closeButtonFull.addEventListener('click', () => {
					this.closeVideoFull();
				});
			}
		}


	}

	openVideo() {
		const Popup = document.querySelector('.vimeo-video-popup');
		const body = document.querySelector('body');
		body.classList.add('overflow-hidden');
		Popup.classList.add('active');

		$("iframe#vimeo-iframe").attr('src', this.vidUrlSrc);

		setTimeout(function() {
			Popup.style.display = 'block';
			//window.location.hash = '';
		}, 200);
	}

	openVideoSecond() {
		const Popup = document.querySelector('.vimeo-video-popup-second');
		const body = document.querySelector('body');
		body.classList.add('overflow-hidden');
		Popup.classList.add('active');

		$("iframe#vimeo-iframe-second").attr('src', this.vidUrlSrcSecond);

		setTimeout(function() {
			Popup.style.display = 'block';
			//window.location.hash = '';
		}, 200);
	}

	openVideoThird() {
		const Popup = document.querySelector('.vimeo-video-popup-third');
		const body = document.querySelector('body');
		body.classList.add('overflow-hidden');
		Popup.classList.add('active');

		$("iframe#vimeo-iframe-third").attr('src', this.vidUrlSrcThird);

		setTimeout(function() {
			Popup.style.display = 'block';
			//window.location.hash = '';
		}, 200);
	}

	openVideoFull() {
		const Popup = document.querySelector('.vimeo-video-popup-full');
		const body = document.querySelector('body');
		body.classList.add('overflow-hidden');
		Popup.classList.add('active');

		$("iframe#vimeo-iframe-full").attr('src', this.vidUrlSrcFull);

		setTimeout(function() {
			Popup.style.display = 'block';
			//window.location.hash = '';
		}, 200);
	}

	closeVideo() {
		const Popup = document.querySelector('.vimeo-video-popup');
		const body = document.querySelector('body');
		const vimeoIframe = document.querySelector('.vimeo-iframe');

		$("iframe#vimeo-iframe").attr('src','');

		body.classList.remove('overflow-hidden');
		Popup.classList.remove('active');

		setTimeout(function() {
			Popup.style.display = 'none';
			//window.location.hash = '';
		}, 200);

	}

	closeVideoSecond() {
		const Popup = document.querySelector('.vimeo-video-popup-second');
		const body = document.querySelector('body');
		const vimeoIframe = document.querySelector('.vimeo-iframe-second');

		$("iframe#vimeo-iframe-second").attr('src','');

		body.classList.remove('overflow-hidden');
		Popup.classList.remove('active');

		setTimeout(function() {
			Popup.style.display = 'none';
			//window.location.hash = '';
		}, 200);

	}

	closeVideoThird() {
		const Popup = document.querySelector('.vimeo-video-popup-third');
		const body = document.querySelector('body');
		const vimeoIframe = document.querySelector('.vimeo-iframe-third');

		$("iframe#vimeo-iframe-third").attr('src','');

		body.classList.remove('overflow-hidden');
		Popup.classList.remove('active');

		setTimeout(function() {
			Popup.style.display = 'none';
			//window.location.hash = '';
		}, 200);

	}

	closeVideoFull() {
		const Popup = document.querySelector('.vimeo-video-popup-full');
		const body = document.querySelector('body');
		const vimeoIframe = document.querySelector('.vimeo-iframe-full');

		$("iframe#vimeo-iframe-full").attr('src','');

		body.classList.remove('overflow-hidden');
		Popup.classList.remove('active');

		setTimeout(function() {
			Popup.style.display = 'none';
			//window.location.hash = '';
		}, 200);

	}

}
